import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { formatApiErrorDetail } from "../lib/apiClient";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not sign in.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16" data-testid="login-page">
      <span className="eyebrow">Researcher account</span>
      <h1 className="font-display font-extrabold text-4xl mt-3">Sign in</h1>
      <p className="text-muted-foreground mt-3">Access your orders, addresses, and faster repeat checkout.</p>
      <form onSubmit={submit} className="card-soft rounded-2xl p-6 sm:p-8 mt-8 space-y-5" data-testid="login-form">
        <div>
          <label className="text-sm font-bold" htmlFor="login-email">Email</label>
          <Input id="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 bg-white" data-testid="login-email" />
        </div>
        <div>
          <label className="text-sm font-bold" htmlFor="login-password">Password</label>
          <Input id="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11 bg-white" data-testid="login-password" />
        </div>
        {error && <p role="alert" className="text-sm text-destructive" data-testid="login-error">{error}</p>}
        <div className="text-right -mt-2">
          <Link to="/forgot-password" className="text-sm font-semibold underline underline-offset-4 text-muted-foreground hover:text-foreground" data-testid="login-forgot-password">Forgot password?</Link>
        </div>
        <button type="submit" disabled={busy} className="w-full h-12 rounded-xl btn-ink font-display font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} Sign in
        </button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        New here? <Link to="/register" className="font-semibold underline underline-offset-4" style={{ color: "var(--gold)" }} data-testid="login-to-register">Create an account</Link>
      </p>
    </div>
  );
}
